import { createZodDto } from "nestjs-zod/dto";
import { z } from "zod";

/**
 * Spec 033 PR-E — payload from the extension's service-worker error proxy
 * (apps/extension/src/background/sentry-proxy.ts) when an MV3 SW catches an
 * unhandled error that can't be reported via @sentry/browser directly
 * (BrowserClient requires a DOM the SW lacks).
 *
 * The server-side endpoint forwards this into Sentry via @sentry/node with
 * a `source: "extension-sw"` tag so the events appear in the same project
 * as the popup + content-script errors.
 */
export const extensionErrorReportSchema = z.object({
  installId: z.string().min(1).max(128),
  surface: z.literal("sw"),
  source: z.string().min(1).max(64),
  message: z.string().min(1).max(2000),
  stack: z.string().max(10_000).optional(),
  context: z.record(z.unknown()).optional(),
  extensionVersion: z.string().max(32),
  manifestVersion: z.number().int().min(2).max(3),
  browserTarget: z.enum(["chromium", "firefox", "safari", "unknown"]),
  occurredAt: z.string().datetime(),
});

export class ExtensionErrorReportDto extends createZodDto(extensionErrorReportSchema) {}
